import configureStore from 'react/redux/store/configureStore';

export default configureStore();